import store from "@/store";
export const printRequest = (url, method, params = {}) => {
  let postNum = store.getters.getPostNum.postNum || "";
  let responseHeader = {
    method: method,
    headers: {
      "print-token": "A8ED868569F32960",
      "Content-Type": "application/json",
    },
  };
  if (method == "post") {
    responseHeader["body"] = JSON.stringify(params);
  }
  return new Promise(function (resolve, reject) {
    fetch(`http://127.0.0.1:${postNum}` + url, responseHeader)
      .then((res) => {
        if (res.status == "200") {
          res.json().then(function (data) {
            resolve(data);
          });
        } else {
          reject(res);
        }
      })
      .catch((res) => {
        resolve({success:false,data:null});
      });
  });
};
